import codeMessages from '@/services/code-messages'
import { TOKEN_NAME } from '@/utils/constants'
import { message } from 'antd'
import axios from 'axios'
import NProgress from 'nprogress'
import { saveToken } from './passport/passport.service'

export interface NbResponse<T> {
  errorCode: string
  data: T
}

const request = axios.create()

const REST_PARAMS = /(:[^/]+)/g
request.interceptors.request.use(
  (config) => {
    NProgress.start()

    const token = localStorage.getItem(TOKEN_NAME)
    const headers = config.headers || {}
    headers['ORBIT-TOKEN'] = token ? token : ''

    const matched = config.url?.match(REST_PARAMS)
    const params = config.params
    let newUrl = config.url
    if (matched && matched.length > 0) {
      matched.forEach((param) => {
        const paramName = param.substring(1)
        const pVal = params?.[paramName]
        if (pVal === undefined) {
          throw new URIError(`[${config.url}][REST] No target value for replacing resource id in url.
                         Params in url must be placed in params within RequestOptions`)
        }
        newUrl = newUrl?.replace(param, pVal)
        delete params?.[paramName]
      })
    }

    return {
      ...config,
      url: newUrl,
      params,
      headers
    }
  },
  (err) => {}
)
request.interceptors.response.use(
  (res) => {
    NProgress.done()
    if (res.status === 200) {
      const resData = res.data

      if (!resData.errorCode) {
        const resolve = resData.meta ? [resData.data, resData.meta] : resData.data
        return Promise.resolve(resolve)
      }

      switch (resData.errorCode) {
        case 'AUTHENTICATION_FAILED':
          const oldLink = window.location.pathname
          if (oldLink && oldLink !== '/') {
            window.location.href = `/entrance/login?redirect_from=${oldLink}`
          } else {
            window.location.href = '/entrance/login'
          }
          break
        case 'PASSWORD_EXPIRED': {
          const { token } = resData.data
          saveToken(token)
          window.location.href = '/entrance/change-password'
          break
        }
        case 'USER_NEED_SIGN_TERMS': {
          const { token, invitationToken } = resData.data
          saveToken(token)
          window.location.href = `/features/invite-confirm/${invitationToken}?resetpassword=true`
          break
        }
      }

      const errMsg = codeMessages[resData.errorCode]

      errMsg && message.error(errMsg)
    }

    return Promise.reject(res)
  },
  (error) => {
    NProgress.done()
    if (axios.isCancel(error)) {
      return Promise.reject(error)
    }
    console.log(error)
    message.error('Server Error')
    return Promise.reject(error)
  }
)

export default request
